import {createSlice, PayloadAction} from "@reduxjs/toolkit";
import {
    TestTakeItem,
    TestTakePagination,
    TestTakeResponse
} from "features/model/types/test/test-student/test-take/testTakeShema";


interface TestTakeState {
    tests: TestTakeItem[];
    pagination: TestTakePagination;
    isLoading: boolean;
}

const testsTakeSlice = createSlice({
    name: "testsTake",
    initialState: {
        tests: [],
        pagination: {} as TestTakePagination,
        isLoading: true,
    } as TestTakeState,
    reducers: {
        setTakeTests: (state, action: PayloadAction<TestTakeResponse>) => {
            const {data} = action.payload;
            state.tests = data.items;
            state.pagination = data.pagination;
            state.isLoading = false;
        },
        setTakeLoading: (state, action: PayloadAction<{ isLoading: boolean }>) => {
            state.isLoading = action.payload.isLoading;
        },
    },
});

export const {setTakeTests, setTakeLoading} = testsTakeSlice.actions;
export const testsTakeReducer = testsTakeSlice.reducer;